import { CSSProperties } from 'react';
import { ReportFontFamily, ReportTextStyle } from '../types';

const FONT_STACKS: Record<ReportFontFamily, string> = {
  sans: 'Arial, Helvetica, sans-serif',
  serif: '"Times New Roman", Times, serif',
  mono: '"Courier New", Courier, monospace',
};

/**
 * Typography of a report element as inline CSS.
 *
 * Inline rather than classes because the values are user data from the designer:
 * an arbitrary colour or point size cannot be expressed as a fixed stylesheet
 * rule. Undefined properties are left out so the sheet's own styling still wins
 * for anything the user did not set.
 */
export const resolveTextStyle = (style?: ReportTextStyle): CSSProperties => {
  if (!style) {
    return {};
  }

  return {
    fontSize: style.fontSizePt ? `${style.fontSizePt}pt` : undefined,
    fontWeight: style.bold ? 700 : undefined,
    fontStyle: style.italic ? 'italic' : undefined,
    textDecoration: style.underline ? 'underline' : undefined,
    color: style.color,
    fontFamily: style.fontFamily ? FONT_STACKS[style.fontFamily] : undefined,
  };
};
